import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13880dee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=13880dee&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=13880dee&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13880dee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13880dee')) {
      api.createRecord('13880dee', component.options)
    } else {
      api.reload('13880dee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13880dee&scoped=true", function () {
      api.rerender('13880dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pageconfig/index.vue"
export default component.exports